<template>
  <!-- 数据统计时间筛选组件 -->
  <div class="page">
    <section class="info-wrap">
      <el-form label-position="left" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px">
        <el-form-item class="style" label="组织机构代码证照片" prop="organizationCopy">
          <div class="img-wrap">
            <div class="img-list">
              <el-upload
                :class="ruleForm.organizationCopy && ruleForm.organizationCopy.length > 0 ? 'hide' : ''"
                list-type="picture-card"
                v-model="ruleForm.organizationCopy"
                :file-list="imgList"
                :action="$configUrl.uploadUrl"
                :on-remove="handleRemove"
                :on-success="
                  (response, file, fileList) => {
                    return handleAvatarSuccess(file, fileList);
                  }
                "
              >
                <i class="el-icon-plus"></i>
              </el-upload>
            </div>
          </div>
        </el-form-item>
        <el-form-item class="style" label="组织机构代码" prop="organizationCode">
          <el-input v-model="ruleForm.organizationCode" placeholder="" clearable></el-input>
        </el-form-item>
        <el-form-item class="style" prop="type" label="证件有效期类型">
          <div>
            <el-radio-group v-model="ruleForm.type">
              <el-radio :label="0">固定有效期</el-radio>
              <el-radio :label="1">长期有效</el-radio>
            </el-radio-group>
          </div>
        </el-form-item>
        <el-form-item label="有效期限开始日期" prop="orgPeriodBegin">
          <el-date-picker
            v-model="ruleForm.orgPeriodBegin"
            type="date"
            placeholder="选择日期"
            clearable
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item v-if="ruleForm.type === 0" label="有效期限结束日期" prop="orgPeriodEnd">
          <el-date-picker
            v-model="ruleForm.orgPeriodEnd"
            type="date"
            placeholder="选择日期"
            clearable
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
    </section>
  </div>
</template>

<script>
export default {
  props: {
    count: {
      type: Number || Boolean,
      default: false,
    },
    subjectData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      imgList: [],
      ruleForm: {
        organizationCopy: [],
        organizationCode: '',
        orgPeriodBegin: '',
        orgPeriodEnd: '',
        type: 0,
      },
      rules: {
        type: [{ required: true, message: '', trigger: ['blur', 'change'] }],
        organizationCopy: [{ required: true, message: '请上传组织机构代码证照片', trigger: ['blur', 'change'] }],
        organizationCode: [{ required: true, message: '请输入组织机构代码', trigger: ['blur', 'change'] }],
        orgPeriodBegin: [{ required: true, message: '请选择有效期限开始日期', trigger: ['blur', 'change'] }],
        orgPeriodEnd: [{ required: true, message: '请选择有效期限结束日期', trigger: ['blur', 'change'] }],
      },
    };
  },

  watch: {
    count: {
      handler: function () {
        this.validity();
      },
    },
    subjectData: {
      handler: function (data) {
        console.log(data);
        this.ruleForm = data.subjectDataVO;
        let organizationCopyList = data.subjectDataVO.organizationCopy.split(',');
        this.imgList = organizationCopyList.map((item) => {
          const fileItem = {
            name: 'file',
            url: item,
            response: {
              data: item,
            },
          };
          return fileItem;
        });
      },
    },
  },

  methods: {
    handleAvatarSuccess(file, fileList) {
      console.log(file, fileList);
      this.ruleForm.organizationCopy = file.response.data.url;
      console.log(this.ruleForm.organizationCopy);
    },
    handleRemove() {
      this.ruleForm.organizationCopy = [];
    },
    validity() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.$emit('confirm', { flag: true, ruleForm: this.ruleForm });
          console.log('验证通过');
        } else {
          this.$emit('confirm', { flag: false, ruleForm: this.ruleForm });
          console.log('验证失败');
          return false;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import '~@/assets/style/mixins.less';
@import '~@/assets/style/var.less';
.info-wrap {
  box-sizing: border-box;
  padding-left: 31px;
}
.img-wrap {
  width: 700px;
  .img-list {
    height: 80px;
    overflow: hidden;
  }
  .hint {
    font-size: 12px;
    transform-origin: left;
    transform: scale(0.9);
    color: #fe4b48;
    margin-bottom: 5px;
  }
  /deep/ .el-upload--picture-card {
    width: 58px;
    height: 58px;
    line-height: 58px;
  }
  /deep/ .el-upload-list {
    /deep/.el-upload-list__item.is-success:first-child {
      &::before {
        position: absolute;
        left: 0;
        top: 0;
        content: '主图';
        color: #fff;
        width: 100%;
        height: 22px;
        font-size: 12px;
        text-align: center;
        line-height: 22px;
        background: rgba(0, 0, 0, 0.36);
      }
    }
  }
  /deep/ .el-upload-list--picture-card .el-upload-list__item {
    width: 80px;
    height: 80px;
    box-sizing: border-box;
  }
  /deep/ .el-upload--picture-card i {
    font-size: 14px;
  }
  /deep/ .el-upload-list__item-actions {
    width: 80px;
    height: 80px;
  }
  .hide {
    /deep/ .el-upload.el-upload--picture-card {
      display: none;
    }
  }
}
.labels-tips {
  font-size: 12px;
  font-weight: 500;
  color: #999999;
}
/deep/.el-input {
  width: 346px;
}
</style>
